module.exports = __webpack_public_path__ + "static/media/ic_primary_openinnewwindow.f6c12ac8.svg";